export enum administrationUrls {
    users = "users"
}